import React from 'react'

const Header = () => {
  return (
    <div className="header-container">
      <div className="header-title">Midtrans Demo Store</div>
    </div>
  );
};

export default Header
